import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values = {
    autoRedirectUrl: String
  }

  connect() {
    if (this.hasAutoRedirectUrlValue && this.autoRedirectUrlValue) {
      console.log('[Notification] Auto-redirecting to:', this.autoRedirectUrlValue);
      setTimeout(() => {
        window.location.href = this.autoRedirectUrlValue;
      }, 1500);
    }
  }

  close() {
    this.element.classList.add('animate-fade-out')
    setTimeout(() => {
      this.element.remove()
    }, 150)
  }
} 
